export const DashboardWalletIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
        <path
            fill="#5C8C8C8C5E61"
            d="M4.5 5H4v14h16V7H7v1h12v10H5V6h14V5H4.5ZM16 13.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
        />
    </svg>
);
